import request from "../helpers/request";
import {createRestfulApi} from "@/api/createRestfulApi";

const URL = {
    USERTENANTSLIST: "tenant/getUserTenants",
    OSSUPLOADURL: "oss/generalUploadUrl",
    GETTENANTCONFIG: "tenant/getTenantConfig",
    SAVETENANTCONFIG: "tenant/saveTenantConfig",
    GET_TENANT_LIST: "tenant/getTenantList",
    GET_TENANT_COPY_LESSON_LIST: "tenant/getTenantCopyLessonList",
    SAVE_TENANT: "tenant/saveTenant",
    ASYNC_TENANT_LESSON: "tenant/asyncTenantLesson",
    COPY_TEST_PAPER_TO_TENANT_ID: "inner/copyTestPaperToTenantId",

    GET_TENANT_INFO: "tenantPay/getTenantInfo",
    GET_COMMERCIAL_PACKAGE: "tenantPay/getCommercialPackage",
    GET_COMMERCIAL_ASSIST_CLASS: "tenantPay/getCommercialAssistClass",
    BUY_PACKAGE: "tenantPay/buyPackage",
    BUY_PRODUCT: "tenantPay/buyProduct",
    GET_PRODUCT_INFO: "tenantPay/getProductInfo",
    GET_ASSIST_CLASS_TASK_INFO: "tenantPay/getAssistClassTaskInfo",
};

export default {
    getTenantList: createRestfulApi(URL.GET_TENANT_LIST, {
        queryParams: [],
    }),
    getTenantCopyLessonList: createRestfulApi(URL.GET_TENANT_COPY_LESSON_LIST, {
        queryParams: [],
    }),
    saveTenant(payload) {
        return request(URL.SAVE_TENANT, "POST", payload);
    },
    asyncTenantLesson(payload) {
        return request(URL.ASYNC_TENANT_LESSON, "POST", payload);
    },
    copyTestPaperToTenantId(payload) {
        return request(URL.COPY_TEST_PAPER_TO_TENANT_ID, "POST", payload);
    },
    getUserTenants() {
        return request(URL.USERTENANTSLIST, "POST");
    },
    generalUploadUrl({contentType}) {
        return request(URL.OSSUPLOADURL, "POST", {
            contentType,
        });
    },
    getTenantConfig() {
        let tenantId = localStorage.getItem("tenantId");
        return request(URL.GETTENANTCONFIG, "POST", {id: tenantId});
    },
    saveTenantConfig(payload) {
        let tenantId = localStorage.getItem("tenantId");
        return request(URL.SAVETENANTCONFIG, "POST", payload);
    },
    getTenantInfo() {
        return request(URL.GET_TENANT_INFO, "POST", null);
    },
    getCommercialPackage() {
        return request(URL.GET_COMMERCIAL_PACKAGE, "POST", null);
    },
    getCommercialAssistClass() {
        return request(URL.GET_COMMERCIAL_ASSIST_CLASS, "POST", null);
    },
    getProductInfo(payload) {
        return request(URL.GET_PRODUCT_INFO, "POST", payload);
    },
    getAssistClassTaskInfo(payload) {
        return request(URL.GET_ASSIST_CLASS_TASK_INFO, "POST", payload);
    },
    buyPackage(payload) {
        return request(URL.BUY_PACKAGE, "POST", payload);
    },
    buyProduct(payload) {
        return request(URL.BUY_PRODUCT, "POST", payload);
    },
};
